/**
 * Export utilities — JSON download, CSV generation
 */

export function downloadJson(data, filename = 'martyr-case.json') {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
  triggerDownload(blob, filename)
}

export function downloadCsv(rows, columns, filename = 'cases.csv') {
  const header = columns.map((c) => `"${c.label}"`).join(',')
  const body = rows
    .map((row) =>
      columns.map((c) => {
        const val = row[c.key] ?? ''
        return `"${String(val).replace(/"/g, '""')}"`
      }).join(',')
    )
    .join('\n')
  const bom  = '\uFEFF' // UTF-8 BOM for Arabic Excel compatibility
  const blob = new Blob([bom + header + '\n' + body], { type: 'text/csv;charset=utf-8;' })
  triggerDownload(blob, filename)
}

export function buildPayload(formData) {
  return {
    applicant_info: {
      name_applicant:      formData.name_applicant,
      relation_applicant:  formData.relation_applicant,
      phone_primary:       formData.phone_primary,
      phone_secondary:     formData.phone_secondary,
      area_applicant:      formData.area_applicant,
    },
    martyr_info: {
      martyr_fullname:       formData.martyr_fullname,
      mother_name:           formData.mother_name,
      birth_date:            formData.birth_date,
      birth_date_accuracy:   formData.birth_date_accuracy,
      current_residence:     formData.current_residence,
      civil_registry_place:  formData.civil_registry_place,
      marital_status:        formData.marital_status,
      photo_publish_consent: formData.photo_publish_consent,
    },
    incident_info: {
      incident_type:    formData.incident_type,
      incidentDetails:  formData.incidentDetails,
      evidence_types:   formData.evidence_types,
    },
    witnesses: {
      has_witnesses: formData.has_witnesses,
      list:          formData.witnesses,
    },
    family_info: {
      spouseExists:                 formData.spouseExists,
      spouse_fullname:              formData.spouse_fullname,
      spouse_birth_year:            formData.spouse_birth_year,
      spouse_current_location:      formData.spouse_current_location,
      spouse_country:               formData.spouse_country,
      children:                     formData.children,
      alternative_provider_exists:  formData.alternative_provider_exists,
      family_support_needs:         formData.family_support_needs,
    },
    contact_info: {
      case_contact_person:              formData.case_contact_person,
      case_contact_relation:            formData.case_contact_relation,
      contact_primary_phone:            formData.contact_primary_phone,
      contact_secondary_phone:          formData.contact_secondary_phone,
      contact_whatsapp:                 formData.contact_whatsapp,
      contact_best_time:                formData.contact_best_time,
      contact_for_verification_consent: formData.contact_for_verification_consent,
      contact_event_notifications:      formData.contact_event_notifications,
    },
    verification: {
      region:                       formData.region,
      neighborhood:                 formData.neighborhood,
      affiliationDeclaration:       formData.affiliationDeclaration,
      allow_official_verification:  formData.allow_official_verification,
      final_signature:              formData.final_signature,
      final_date:                   formData.final_date,
    },
  }
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a   = document.createElement('a')
  a.href    = url
  a.download = filename
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export const CSV_COLUMNS = [
  { key: 'readable_id',      label: 'رقم الحالة' },
  { key: 'martyr_fullname',  label: 'اسم الشهيد' },
  { key: 'mother_name',      label: 'اسم الأم' },
  { key: 'birth_date',       label: 'تاريخ الميلاد' },
  { key: 'region',           label: 'المنطقة' },
  { key: 'neighborhood',     label: 'الحي' },
  { key: 'incident_type',    label: 'نوع الحادثة' },
  { key: 'status',           label: 'الحالة' },
  { key: 'created_at',       label: 'تاريخ التقديم' },
]
